import { render, staticRenderFns } from "./SectionBody.vue?vue&type=template&id=8f9c9a8c&"
import script from "./SectionBody.vue?vue&type=script&lang=js&"
export * from "./SectionBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports